export default __webpack_public_path__ + "static/media/MobileIcon.c7f8cc34.svg";